import { Box, Container, LinearProgress } from '@material-ui/core';

import { useScreen } from '@/hooks/useScreen';

export const Loading = () => {
  const { xs } = useScreen();
  return (
    <Container maxWidth={'xs'} style={{ padding: 0 }}>
      <Box minHeight={xs ? 800 : 490} display={'flex'} alignItems={'center'}>
        <LinearProgress style={{ width: '100%' }} />
      </Box>
    </Container>
  );
};
